import NumberFormat from 'react-number-format';
import React from 'react';
import { toast } from 'react-toastify';
import IconToast from '../../../../components/NewToast';

// v9: MUI's Input passes a ref to inputComponent — must be forwardRef-aware,
// otherwise we get the "Function components cannot be given refs" warning.
// react-number-format v4 exposes its inner <input> ref via getInputRef.
const NumberFormatInputWrapper = React.forwardRef(function NumberFormatInputWrapper(props, ref) {
  const { intl, onChange, ...rest } = props;

  const handleInput = event => {
    const { value } = event.target;

    const valueWithoutCommas = value.replace(/,/g, '');
    const validNumberPattern = /^(?!0\d)\d*\.?\d*%?$/;
    if (valueWithoutCommas && !validNumberPattern.test(valueWithoutCommas)) {
      toast.dismiss();
      const message = intl ? intl.formatMessage({ id: 'please-enter-number' }) : 'Please enter a number';
      toast.warn(IconToast('warn', message), { className: 'new-toast' });
    }
  };

  const handleValueChange = values => {
    const { value } = values;

    onChange({
      target: {
        name: props.name,
        value: value !== '' ? parseFloat(value) : undefined
      }
    });
  };

  return (
    <NumberFormat
      {...rest}
      getInputRef={ref}
      decimalSeparator="."
      thousandSeparator=","
      inputMode="decimal"
      pattern="[0-9]*"
      allowNegative={false}
      onValueChange={handleValueChange}
      onInput={handleInput}
    />
  );
});

export default NumberFormatInputWrapper;
